import React from "react";

export default function FAQItem({ q, a }) {
  return (
    <div className="faq-item">
      <h4>{q}</h4>
      <p>{a}</p>
    </div>
  );
}
